/**
 * Created by toomasp on 31.08.2015.
 */
'use strict';

/**
 Provides compatibility with traditional form submit logic where whole view is replaced with the response.
 Add class="proxy-form" to activate
 */
export default ['navi', 'ui', 'app', 'debug', (navi, ui, app, dbg)=> {
    function successHandler(viewHtml, status, request) {
        let route = navi.getCurrent();
        let redirect = request.getResponseHeader('Location');
        if (redirect) {
            navi.openUrl(redirect);
        } else {
            ui.replacePartialComponentHtml('.' + route.component, viewHtml);
            app.validate();
        }
    }

    function errorHandler(msg) {
        dbg.log(msg);
    }

    function getPostUrl(element) {
        let actionPath = $(element).attr('action');
        if (actionPath.substring(0, 1) == '/')
            actionPath = actionPath.substring(1);
        return '../proxy/' + actionPath;
    }

    function serializeForm(element, submitActorHolder) {
        var data = $(element).serialize();
        if (data.length) {
            data += '&';
        }
        // Fix spaces being encoded as +
        data = data.replace(/\+/g, '%20');
        data += submitActorHolder.name + '=' + submitActorHolder.value;
        return data;
    }

    function getFormData(element, submitActorHolder) {
        var data = new FormData($(element)[0]);
        data.append(submitActorHolder.name, submitActorHolder.value);
        return data;
    }

    function doMultipartPost(element, submitActorHolder) {
        $.ajax({
            url: getPostUrl(element),
            type: 'POST',
            data: getFormData(element, submitActorHolder),
            contentType: false,
            processData: false,
            success: successHandler,
            error: errorHandler
        });
    }

    function doPost(element, submitActorHolder) {
        $.ajax({
            url: getPostUrl(element),
            type: 'POST',
            data: serializeForm(element, submitActorHolder),
            success: successHandler,
            error: errorHandler
        });
    }

    function doGet(element, submitActorHolder) {
        let url = $(element).attr('action');
        if (url && url.indexOf('/') === 0)
            url = url.substring(1)

        app.location.path(url);
        app.location.search(serializeForm(element, submitActorHolder));
        app.validate();
    }

    function setSubmitActor(form, uid, submitActorHolder) {
        var currentActor = document.getElementById(uid + 'actor');

        var actor = currentActor || document.createElement('INPUT');
        actor.setAttribute('type', 'hidden');
        actor.setAttribute('name', submitActorHolder.name);
        actor.setAttribute('value', submitActorHolder.value);

        if (!currentActor) {
            $(form).append(actor);
        }
    }

    function prepareIframeBasedPost(form, submitActorHolder) {
        var uid = new Date().getTime() + '' + Math.random();

        var iframe = document.createElement('IFRAME');
        iframe.setAttribute('name', uid);
        iframe.style.display = 'none';

        $(form).attr('action', getPostUrl(form));
        $(form).attr('target', uid);
        $(form).after(iframe);

        $(form).on('submit', function (event) {
            // Since targeted form loses submit button name and value parameters have to add them manually
            setSubmitActor(form, uid, submitActorHolder);

            $(iframe).load(function () {
                var html = $(iframe).contents().find('body').html();
                var route = navi.getCurrent();
                ui.replacePartialComponentHtml('.' + route.component, html);
                app.validate();
            });
        });
    }


    class ProxyFormDirective {
        restrict = 'C';

        link(scope, element, attr) {
            var method = attr.method || 'GET';
            method = method.toUpperCase();

            var encoding = attr.enctype || '';
            encoding = encoding.toUpperCase();

            // Capture the submit button clicked on
            var submitActorHolder = {};
            $(element).find('input[type=submit]').on('click touchstart', function () {
                var target = $(this);
                submitActorHolder.name = target.attr('name');
                submitActorHolder.value = target.attr('value');
            });

            // Multipart post and browser does not support ajax async file upload
            if (method === 'POST' && encoding === 'MULTIPART/FORM-DATA' && typeof window.FormData !== 'function') {
                prepareIframeBasedPost(element, submitActorHolder);
                return;
            }

            $(element).on('submit', function (event) {
                event.preventDefault();

                if (method === 'GET') {
                    doGet(element, submitActorHolder);
                } else if (encoding === 'MULTIPART/FORM-DATA') {
                    doMultipartPost(element, submitActorHolder);
                } else {
                    doPost(element, submitActorHolder);
                }
            });
        }
    }
    return new ProxyFormDirective();
}];


// WEBPACK FOOTER //
// ./src/ui/core/common/directives/decorator/proxy-form.directive.js